import React, { useEffect } from 'react'
import { Box, Button, IconButton, Typography, Modal, TextField, Grid } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useState } from 'react'

const CSTicketModal = ({
  open,
  setOpen,
  defaultAffiliateCode,
  setAffiliateCode,
  defaultTicketARC,
  setTicketArc,
  defaultAgentName,
  setAgentName,
  handleSupportSubmit,
}) => {
  const [ticketDescription, setTicketDescription] = useState('')
  //   const []


  return (
    <Modal
      open={open}
      onClose={() => {setTicketDescription(''); setOpen(false);}}
      sx={{
        marginTop: '12rem',
      }}
    >
      <Box sx={appManagementStyle.whiteBox}>
        <Grid container item lg={12} sm={12} display={'flex'} justifyContent={'end'} alignItems={'center'}>
          <IconButton onClick={() => {setTicketDescription(''); setOpen(false);}}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid
          container
          spacing={2}
          alignItems={'center'}
          sx={{ paddingX: { lg: '40px', md: '40px', sm: '40px', xs: '0px' } }}
        >
          <Grid item lg={12} sm={12} xs={12}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { lg: '36px', md: '36px', sm: '36px', xs: '24px' },
              }}
              align="center"
              textAlign={'center'}
            >
              Customer Support Ticket
            </Typography>
          </Grid>
          <Grid item lg={12} sm={12}>
            <Typography color="#64768C" fontSize={'16px'} align="center" marginBottom={'8px'}>
              Fill out the information below to submit your ticket.
            </Typography>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextField
              sx={appManagementStyle.textField}
              label="ARCID"
              placeholder="ex. ARC7324944940"
              onChange={(e) => setTicketArc(e.target.value)}
              defaultValue={defaultTicketARC}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextField
              sx={appManagementStyle.textField}
              label="Agent Name"
              placeholder="ex. John Smith"
              onChange={(e) => setAgentName(e.target.value)}
              defaultValue={defaultAgentName}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextField
              sx={appManagementStyle.textField}
              label="Agent Affiliate Code"
              placeholder="ex. SFG0000003"
              disabled={true}
              defaultValue={defaultAffiliateCode}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              sx={appManagementStyle.textArea}
              label="Describe your issue"
              value={ticketDescription}
              placeholder="Enter a description"
              onChange={(e) => setTicketDescription(e.target.value)}
              InputLabelProps={{ shrink: true }}
              multiline
              rows={5}
            />
          </Grid>
        </Grid>
        <Button onClick={() => handleSupportSubmit(ticketDescription)} sx={appManagementStyle.nextButton}>
          Submit
        </Button>
      </Box>
    </Modal>
  )
}

export default CSTicketModal

const appManagementStyle = {
  nextButton: {
    textTransform: 'none',
    width: { lg: '50%', md: '50%', sm: '50%', xs: '60%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '20px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  textField: {
    backgroundColor: 'white',
    width: '100%',
  },

  textArea: {
    backgroundColor: 'white',
    width: '100%',
  },

  whiteBox: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingX: '20px',
    paddingTop: '40px',
    paddingBottom: '60px',
    width: { lg: '844px', md: '730px', sm: '730px', xs: '303px' },
    height: { lg: '438px', md: '438px', sm: '438px', xs: '500px' },
    background: '#FFFFFF',
    borderRadius: '8px',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}
